import { useState, useEffect, useRef } from "react";
import { images, useOutsideClickHeader } from "../../action/customFn";
import {
  AboutNavIcon,
  AngleRightArrow,
  BlogNavIcon,
  CommunityNavIcon,
  CourseIconFour,
  CourseIconOne,
  CourseIconThree,
  CourseIconTwo,
  CourseNavIcon,
  RightArrow,
  svgObj,
} from "../../asset/icons/Icons";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import { LiaAngleDownSolid, LiaAngleUpSolid } from "react-icons/lia";
import { RiBriefcase2Fill, RiMedal2Line, RiUser2Line } from "react-icons/ri";
import { FaArrowTrendUp, FaCaretDown } from "react-icons/fa6";
//import styles 👇
import "react-modern-drawer/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import {
  asyncGetAllPrograms,
  asyncGetTotalCourses,
} from "../../action/courseAction";
import { asyncGetAllMasterclass } from "../../action/masterclassAction";
import { Image, Shimmer } from "react-shimmer";
import useScrollDirection from "../../hooks/useScrollDirection";
import { ColorRing } from "react-loader-spinner";
import { AnimatePresence, motion } from "framer-motion";
import { PopupModal } from "react-calendly";
import { IoMenu } from "react-icons/io5";
import { BiCaretDown } from "react-icons/bi";

const AboutRoutes = {
  whyMetBrains: "/about",
  meetourteam: "/meet-our-team",
  contactus: "/contact-us",
  jointeam: "/jobs",
  ourpolicy: "/our-policy",
};

const BlogRoutes = {
  recentblogs: "/blogs",
  testimonialvideo: "/testimonial-video",
  ourpolicy: "/our-policy",
  ourblogs: "/blogs",
  blogregister: "/blog-register",
};

const CommunityRoutes = {
  facultyandmentors: "/mentors",
  placedCandidate: "/placed-candidates",
  familysupport: "/",
  whatTestimonies: "/reviews",
};

const VirtualInternshipRoutes = {
  study_and_internship: "/study-and-internship",
  apply_now: "/apply",
  virtual: "/virtual-internship-experiance",
  placed: "/placed-testimonies",
  oyip: "/oyip",
};

// become-instructor
// hire-us
const MainHeaderRoutes = {
  become_instructor: "/become-instructor",
  hire_from_us: "/hire-us",
};

const Header = ({ isnotOptions }) => {
  const [headerList, setHeaderList] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [mobileHeaderList, setMobileHeaderList] = useState(3);
  const [mobilecourseList, setMobileCourseList] = useState(1);
  const [searchList, setSearchList] = useState([]);
  const [isFocus, setIsFocus] = useState(false);
  const [calpop, setCalpop] = useState(false);
  const [showBootcampsDropdown, setShowBootcampsDropdown] = useState(false);
  const navigate = useNavigate();
  const searchRef = useRef("");
  const dispatch = useDispatch();
  const bootcampsDropdownRef = useRef(null);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const allcourses = useSelector((state) => state.courseData.allcourses);
  const allPrograms = useSelector((state) => state.courseData.allprograms);
  const isLoggedIn = useSelector((state) => state.login);
  const profileData = useSelector((state) => state.profileData);
  const masterclassArr = useSelector(
    (state) => state.masterclassData.allmasterclass
  );

  const hideOverflowBody = () => {
    window.scroll(0, 0);
    document.body.style.overflowY = "hidden";
    document.querySelector("html").style.overflowY = "hidden";
  };

  const closeBar = () => {
    document.body.style.overflowY = "auto";
    document.querySelector("html").style.overflowY = "auto";
    setHeaderList(0);
  };

  const { pathname } = useLocation();
  useOutsideClickHeader(bootcampsDropdownRef, () =>
    setShowBootcampsDropdown(false)
  );

  const isBootcampsActive =
    pathname === "/bootcamps" ||
    pathname.startsWith("/datacamp/") ||
    pathname.startsWith("/cybercamp/");

  useEffect(() => {
    document.body.style.overflowY = "auto";
    document.querySelector("html").style.overflowY = "auto";
    window.scroll(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (headerList === 0) {
      closeBar();
    }
  }, [headerList]);

  useEffect(() => {
    // const query = {
    //   type: "Course",
    // };
    const query_program = { type: "Program" };
    // dispatch(asyncGetAllCourses(query));
    dispatch(asyncGetAllPrograms(query_program));
    dispatch(asyncGetTotalCourses());
    dispatch(asyncGetAllMasterclass({ active: true }));
  }, []);

  const filterData = (query) => {
    const filterArr = allPrograms.filter((item) =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );
    setSearchList(filterArr);
  };

  useEffect(() => {
    if (isOpen) {
      hideOverflowBody();
    } else {
      closeBar();
    }
  }, [isOpen]);

  return (
    <>
      <PopupModal
        url="https://calendly.com/team-metbrains/30min"
        onModalClose={() => setCalpop(false)}
        open={calpop}
        rootElement={document.getElementById("root")}
      />
      <div className="home_main_header_container">
        <div
          className="home_header_container"
          style={{ background: "#2b2b2b" }}
        >
          <div className="home_header_left">
            <div className="home_header_logo">
              <NavLink to={"/"}>
                <img alt="" src={images["Metbrains_logo_shadow.png"]} />
              </NavLink>
            </div>
            <ul
              style={{
                listStyle: "none",
                display: "flex",
                alignItems: "center",
                marginBottom: "0px",
                gap: "30px",
              }}
            >
              <li style={{ cursor: "pointer" }}>
                <NavLink
                  to={"/"}
                  style={{
                    fontWeight: location.pathname === "/" ? "600" : "500",
                    color:
                      location.pathname === "/"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                >
                  Home
                </NavLink>
              </li>
              <li style={{ cursor: "pointer" }}>
                <NavLink
                  style={{
                    fontWeight: location.pathname === "/about" ? "600" : "500",
                    color:
                      location.pathname === "/about"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                  to={AboutRoutes.whyMetBrains}
                >
                  About
                </NavLink>
              </li>

              <li
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/programs");
                }}
              >
                <span
                  style={{
                    fontWeight:
                      location.pathname === "/programs" ? "600" : "500",
                    color:
                      location.pathname === "/programs"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                >
                  Our Programs
                </span>
              </li>

              <li
                ref={bootcampsDropdownRef}
                style={{ cursor: "pointer", position: "relative" }}
                onMouseEnter={() => setShowBootcampsDropdown(true)}
              >
                <span
                  role="button"
                  tabIndex={0}
                  // onClick={() => navigate("/bootcamps")}
                  onFocus={() => setShowBootcampsDropdown(true)}
                  onBlur={() => setShowBootcampsDropdown(false)}
                  style={{
                    fontWeight:
                      isBootcampsActive ? "600" : "500",
                    color:
                      isBootcampsActive
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                >
                  Bootcamps <BiCaretDown />
                </span>

                <AnimatePresence>
                  {showBootcampsDropdown && (
                    <motion.div
                      onMouseLeave={() =>
                        setShowBootcampsDropdown(false)
                      }
                      aria-label="Bootcamps dropdown"
                      initial={{ opacity: 0, y: -10, scale: 0.98 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -10, scale: 0.98 }}
                      transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 26,
                      }}
                      style={{
                        position: "absolute",
                        top: "calc(100% + 14px)",
                        left: "0%",
                        transform: "translateX(-50%)",
                        width: "420px",
                        padding: "16px",
                        borderRadius: "16px",
                        background: "#0f0f0f",
                        border:
                          "1px solid rgba(255, 255, 255, 0.12)",
                        boxShadow:
                          "0px 24px 70px rgba(0, 0, 0, 0.45)",
                        zIndex: 9999999999,
                        overflow: "hidden",
                      }}
                    >
                      {/* Header */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                          paddingInline: "6px",
                          paddingBottom: "12px",
                          borderBottom:
                            "1px solid rgba(255, 255, 255, 0.08)",
                          marginBottom: "12px",
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              background:
                                "oklch(62.3% 0.214 259.815)",
                              marginTop: "6px",
                              boxShadow:
                                "0 0 0 4px rgba(109,91,255,0.14)",
                            }}
                          />
                          <div>
                            <div
                              style={{
                                fontWeight: 800,
                                fontSize: 14,
                              }}
                            >
                              Ongoing Bootcamps
                            </div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.78,
                                marginTop: 2,
                              }}
                            >
                              Two intensive 7-day tracks
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 12,
                            opacity: 0.7,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Click to view details
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        {/* <Link
                          to="/datacamp/7-day-data-camp"
                          onClick={() =>
                            setShowBootcampsDropdown(false)
                          }
                          style={{
                            textDecoration: "none",
                            color: "white",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            padding: "14px 14px",
                            borderRadius: "14px",
                            background: "rgba(255, 255, 255, 0.06)",
                            border:
                              "1px solid rgba(255, 255, 255, 0.14)",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              inset: 0,
                              background:
                                "radial-gradient(500px circle at 10% 0%, rgba(109, 91, 255, 0.30), transparent 60%)",
                              pointerEvents: "none",
                            }}
                          />

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <div style={{ display: "flex", gap: "12px" }}>
                              <div
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 12,
                                  background:
                                    "linear-gradient(135deg, rgba(109, 91, 255, 0.30), rgba(255,255,255,0.06))",
                                  border:
                                    "1px solid rgba(109, 91, 255, 0.45)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: 900,
                                  letterSpacing: "0.2px",
                                }}
                              >
                                DC
                              </div>
                              <div>
                                <div
                                  style={{
                                    fontWeight: 900,
                                    fontSize: 14,
                                  }}
                                >
                                  Data Camp
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    opacity: 0.83,
                                    marginTop: 2,
                                  }}
                                >
                                  Data Analytics Bootcamp
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                opacity: 0.92,
                                marginTop: 3,
                              }}
                            >
                              <RightArrow />
                            </div>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {["7 Days", "3 Domains", "Demo Day"].map(
                              (pill) => (
                                <span
                                  key={pill}
                                  style={{
                                    fontSize: 12,
                                    padding:
                                      "6px 9px",
                                    borderRadius: 999,
                                    background:
                                      "rgba(255,255,255,0.05)",
                                    border:
                                      "1px solid rgba(255,255,255,0.10)",
                                    opacity: 0.92,
                                  }}
                                >
                                  {pill}
                                </span>
                              )
                            )}
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                              marginTop: 2,
                            }}
                          >
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                              <span
                                style={{
                                  color: "#ffcc33",
                                  fontSize: 14,
                                  lineHeight: 1,
                                }}
                              >
                                ★
                              </span>
                              <span
                                style={{
                                  fontWeight: 900,
                                  fontSize: 12,
                                }}
                              >
                                4.62
                              </span>
                              <span
                                style={{
                                  fontSize: 12,
                                  opacity: 0.76,
                                  fontWeight: 700,
                                }}
                              >
                                Avg rating
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: 12,
                                opacity: 0.68,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Ongoing batch
                            </span>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              fontSize: 12,
                              opacity: 0.78,
                              lineHeight: 1.35,
                            }}
                          >
                            "Hands-on mentorship that turns raw data into production insights."
                          </div>
                        </Link> */}

                        <Link
                          to="/cybercamp/4-day-cyber-camp"
                          onClick={() =>
                            setShowBootcampsDropdown(false)
                          }
                          style={{
                            textDecoration: "none",
                            color: "white",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            padding: "14px 14px",
                            borderRadius: "14px",
                            background: "rgba(255, 255, 255, 0.06)",
                            border:
                              "1px solid rgba(255, 255, 255, 0.14)",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              inset: 0,
                              background:
                                "radial-gradient(500px circle at 10% 0%, rgba(0, 229, 255, 0.28), transparent 60%)",
                              pointerEvents: "none",
                            }}
                          />

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <div style={{ display: "flex", gap: "12px" }}>
                              <div
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 12,
                                  background:
                                    "linear-gradient(135deg, rgba(0, 229, 255, 0.26), rgba(255,255,255,0.06))",
                                  border:
                                    "1px solid rgba(0, 229, 255, 0.45)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: 900,
                                  letterSpacing: "0.2px",
                                }}
                              >
                                CC
                              </div>
                              <div>
                                <div
                                  style={{
                                    fontWeight: 900,
                                    fontSize: 14,
                                  }}
                                >
                                  Cyber Camp
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    opacity: 0.83,
                                    marginTop: 2,
                                  }}
                                >
                                  Cyber Security Bootcamp
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                opacity: 0.92,
                                marginTop: 3,
                              }}
                            >
                              <RightArrow />
                            </div>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {["4 Days", "5 Domains", "OSINT + Python"].map(
                              (pill) => (
                                <span
                                  key={pill}
                                  style={{
                                    fontSize: 12,
                                    padding:
                                      "6px 9px",
                                    borderRadius: 999,
                                    background:
                                      "rgba(255,255,255,0.05)",
                                    border:
                                      "1px solid rgba(255,255,255,0.10)",
                                    opacity: 0.92,
                                  }}
                                >
                                  {pill}
                                </span>
                              )
                            )}
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                              marginTop: 2,
                            }}
                          >
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                              <span
                                style={{
                                  color: "#ffcc33",
                                  fontSize: 14,
                                  lineHeight: 1,
                                }}
                              >
                                ★
                              </span>
                              <span
                                style={{
                                  fontWeight: 900,
                                  fontSize: 12,
                                }}
                              >
                                4.82
                              </span>
                              <span
                                style={{
                                  fontSize: 12,
                                  opacity: 0.76,
                                  fontWeight: 700,
                                }}
                              >
                                Avg rating
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: 12,
                                opacity: 0.68,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Ongoing batch
                            </span>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              fontSize: 12,
                              opacity: 0.78,
                              lineHeight: 1.35,
                            }}
                          >
                            "Learn ethical hacking fundamentals with guided recon & mini-projects."
                          </div>
                        </Link>
                      </div>

                      {/* Footer CTA */}
                      <div style={{ marginTop: "14px" }}>
                        {/* <Link
                          to="/"
                          onClick={() =>
                            setShowBootcampsDropdown(false)
                          }
                          style={{
                            width: "100%",
                            textDecoration: "none",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            padding: "11px 12px",
                            borderRadius: "12px",
                            background:
                              "rgba(255, 255, 255, 0.06)",
                            border:
                              "1px solid rgba(255, 255, 255, 0.14)",
                            fontWeight: 800,
                            fontSize: 13,
                            opacity: 0.92,
                          }}
                        >
                          View all bootcamps <RightArrow />
                        </Link> */}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>

              <li style={{ cursor: "pointer" }}>
                <NavLink
                  style={{
                    fontWeight:
                      location.pathname === "/reviews" ? "600" : "500",
                    color:
                      location.pathname === "/reviews"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                  to={"/reviews"}
                >
                  Testimonials
                </NavLink>
              </li>
              <li style={{ cursor: "pointer" }}>
                <NavLink
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: location.pathname === "/test" ? "600" : "500",
                    color:
                      location.pathname === "/test"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                  to={"/test"}
                >
                  Mock Tests
                </NavLink>
              </li>
              <li style={{ cursor: "pointer" }}>
                <NavLink
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: location.pathname === "/jobs" ? "600" : "500",
                    color:
                      location.pathname === "/jobs"
                        ? "oklch(62.3% 0.214 259.815)"
                        : "white",
                  }}
                  to={"/jobs"}
                >
                  Jobs
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="home_header_right">
            <ul>
              <li
                style={{ display: "flex", alignItems: "stretch", gap: "10px" }}
              >

                {/* <DataCampBadgeLink /> */}
                {/* <button
                  className="gemini-ats-btn"
                  onClick={() => {
                    navigate("/evaluate-your-resume");
                  }}
                >
                  <img src="/gemini-color.svg" style={{ width: "22px" }} />
                  <span>ATS</span>
                </button> */}
                <button
                  className="neo-xnmrph-btn-blue"
                  onClick={() => setCalpop(true)}
                >
                  <img
                    src="/calendly-logo.svg"
                    width={20}
                    style={{ width: "20px", marginRight: "7px" }}
                  />
                  Talk to a Counselor
                </button>
                <Link
                  to={"/login"}
                  style={{
                    color: "#fff",
                    background: "rgba(194, 212, 237, 0.2)",
                    padding: "9px 15px",
                    borderRadius: "5px",
                  }}
                >
                  Log In
                </Link>
              </li>
              <li>
                {isLoggedIn && (
                  <NavLink
                    to={
                      localStorage.getItem("MetBrains_role") === "Student"
                        ? "/dashboard/profile"
                        : "/blog-dashboard/home"
                    }
                  >
                    {" "}
                    <img src={profileData.image} alt="" />
                  </NavLink>
                )}
              </li>
            </ul>
          </div>
        </div>

        {!isnotOptions && (
          <div className="position-relative">
            <AnimatePresence mode="wait">
              {headerList !== 0 && (
                <div className={"header_main_div"}>
                  {headerList === 1 && (
                    <HomeAbout
                      closeBar={closeBar}
                      setHeaderList={setHeaderList}
                    />
                  )}
                  {headerList === 2 && (
                    <HomeVirtual
                      closeBar={closeBar}
                      setHeaderList={setHeaderList}
                    />
                  )}
                  {headerList === 3 && (
                    <HomeCourse
                      closeBar={closeBar}
                      allcourses={allcourses}
                      allPrograms={allPrograms}
                      masterclassArr={masterclassArr}
                      setHeaderList={setHeaderList}
                    />
                  )}
                  {headerList === 4 && (
                    <HomeCommunity
                      closeBar={closeBar}
                      setHeaderList={setHeaderList}
                    />
                  )}
                  {headerList === 5 && (
                    <HomeBlogs
                      closeBar={closeBar}
                      setHeaderList={setHeaderList}
                    />
                  )}
                </div>
              )}
            </AnimatePresence>
          </div>
        )}
      </div>
      <div className="home_main_mobile_nav">
        <div className="home_mobile_nav">
          <div style={{width:"190px"}}> 
          <NavLink to={"/"}>
            <img alt="" src={images["Metbrains_logo_shadow.png"]} />
          </NavLink>
          </div>
          <button
            onClick={() => {
              toggleDrawer();
            }}
          >
            <IoMenu color="oklch(62.3% 0.214 259.815)" />
          </button>
        </div>
        <Drawer
          open={isOpen}
          onClose={toggleDrawer}
          direction="left"
          className="home_mobile_drawer"
        >
          <div className="mobile_nav_header">
            <div className="mobile_nav_logo">
              <div className="mobile_nav_profile">
                {isLoggedIn && (
                  <NavLink to={"/dashboard/profile"}>
                    <img alt="" src={profileData.image} />
                  </NavLink>
                )}
              </div>
              {/* <button>Register</button> */}
            </div>
            <div className="main_mobile_nav_conatiner">
              <div className="mobile_nav_list">
                <ul>
                  <li>
                    <div className="drop_item">
                      <NavLink to={"/about"} className="mobile_nav_item">
                        <AboutNavIcon />
                        <span>About</span>
                      </NavLink>
                    </div>
                  </li>

                  <li>
                    <div
                      className="drop_item"
                      onClick={() =>
                        setMobileHeaderList((p) => (p === 3 ? 0 : 3))
                      }
                    >
                      <div className="mobile_nav_item">
                        <CourseNavIcon />
                        <span>Our Programs</span>
                      </div>
                      {mobileHeaderList === 3 ? (
                        <LiaAngleUpSolid />
                      ) : (
                        <LiaAngleDownSolid />
                      )}
                    </div>
                    {mobileHeaderList === 3 && (
                      <>
                        <div className="mobile_course_steps">
                          <div className="mobile_course_step_item">
                            <span
                              className={`${
                                mobilecourseList === 1 ? "active" : ""
                              } `}
                              onClick={() => setMobileCourseList(1)}
                            >
                              Program <AngleRightArrow />
                            </span>
                            {mobilecourseList === 1 && (
                              <div className="mobile_course_step_list">
                                <ul>
                                  {allPrograms.length &&
                                    allPrograms
                                      .filter(
                                        (item) =>
                                          !(
                                            item.slug ===
                                              "digital-marketing-program"
                                          )
                                      )
                                      .map((data, i) => {
                                        return (
                                          <li key={i}>
                                            <NavLink to={`/${data.slug}`}>
                                              {data.category}
                                            </NavLink>
                                          </li>
                                        );
                                      })}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </li>
                  <li>
                    <div className="drop_item">
                      <NavLink to={"/reviews"} className="mobile_nav_item">
                        <CommunityNavIcon />
                        <span>Placed Testimonials</span>
                      </NavLink>
                    </div>
                  </li>
                  <li>
                    <div className="drop_item">
                      <NavLink
                        to={"/evaluate-your-resume"}
                        className="mobile_nav_item"
                      >
                        {/* <RiGeminiFill /> */}
                        <img
                          src="/gemini-color.svg"
                          style={{ width: "22px" }}
                        />

                        <span>Evaluate Your Resume</span>
                      </NavLink>
                    </div>
                  </li>
                  <li>
                    <div className="drop_item">
                      <NavLink
                        to={"/mentor-application-form"}
                        className="mobile_nav_item"
                      >
                        <CommunityNavIcon />
                        <span>Teach on Metbrains</span>
                      </NavLink>
                    </div>
                  </li>
                  <li>
                    <div className="drop_item">
                      <NavLink
                        to={"/jobs"}
                        className="mobile_nav_item"
                      >
                        <span>Jobs</span>
                      </NavLink>
                    </div>
                  </li>
                  <li>
                    <div className="drop_item">
                      <NavLink
                        to={"https://hirist-rps.web.app/login"}
                        className="mobile_nav_item"
                      >
                        <span>Recruiter Login</span>
                      </NavLink>
                    </div>
                  </li>
                </ul>
              </div>

              {!isLoggedIn && (
                <button
                  className="mobile_nav_login"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              )}
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default Header;

const SearchBar = ({ searchList, setIsFocus, searchRef }) => {
  const navigate = useNavigate();

  const [currentEvent, setEvent] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsFocus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    setEvent(true);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [currentEvent]);
  return (
    <div className="header_search_bar_list">
      {searchList.length ? (
        <ul>
          {searchList.map((data, i) => {
            return (
              <li onClick={() => navigate(`/${data.slug}`)} key={i}>
                {data.title}{" "}
                {data.type === "Program"
                  ? "Training & Internship"
                  : "Certification Course"}
              </li>
            );
          })}
        </ul>
      ) : (
        <h6 className="text-center p-3">No Results Found !</h6>
      )}
    </div>
  );
};

const ICONS_ARR = [
  {
    icon: <CourseIconOne />,
  },
  {
    icon: <CourseIconTwo />,
  },
  {
    icon: <CourseIconThree />,
  },
  {
    icon: <CourseIconFour />,
  },
  {
    icon: <CourseIconOne />,
  },
];

export const HomeCourse = () => {
  function getRating(title) {
    const lowerTitle = title.trim().toLowerCase();

    // Fixed cases
    if (lowerTitle === "cyber security") {
      return 4.82;
    }
    if (lowerTitle === "data science") {
      return 4.7;
    }
    if (lowerTitle === "data analytics") {
      return 4.62;
    }
    if (lowerTitle === "business analytics") {
      return 4.36;
    }
    if (lowerTitle === "devops engineering") {
      return 4.44;
    }
    if (lowerTitle === "digital marketing") {
      return 4.21;
    }
    if (lowerTitle === "data engineering") {
      return 4.66;
    }

    // Random rating between 4.01 and 4.819
    const rating = (Math.random() * (4.819 - 4.01) + 4.01).toFixed(2);
    return parseFloat(rating);
  }
  const [showHomeMenu, setShowHomeMenu] = useState(false);
  const [showAboutMenu, setShowAboutMenu] = useState(false);

  const { scrollDirection, isTop } = useScrollDirection();

  const [headerList, setHeaderList] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [mobileHeaderList, setMobileHeaderList] = useState(0);
  const [mobilecourseList, setMobileCourseList] = useState(1);
  const [searchList, setSearchList] = useState([]);
  const [isFocus, setIsFocus] = useState(false);
  const navigate = useNavigate();
  const searchRef = useRef("");
  const dispatch = useDispatch();
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const [currentCard, setCurrentCard] = useState(1);

  const allcourses = useSelector((state) => state.courseData.allcourses);
  const allPrograms = useSelector((state) => state.courseData.allprograms);
  const isLoggedIn = useSelector((state) => state.login);
  const profileData = useSelector((state) => state.profileData);
  const masterclassArr = useSelector(
    (state) => state.masterclassData.allmasterclass
  );

  const hideOverflowBody = () => {
    window.scroll(0, 0);
    document.body.style.overflowY = "hidden";
    document.querySelector("html").style.overflowY = "hidden";
  };

  const closeBar = () => {
    document.body.style.overflowY = "auto";
    document.querySelector("html").style.overflowY = "auto";
    setHeaderList(0);
  };

  const { pathname } = useLocation();

  useEffect(() => {
    document.body.style.overflowY = "auto";
    document.querySelector("html").style.overflowY = "auto";
    window.scroll(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (headerList === 0) {
      closeBar();
    }
  }, [headerList]);

  useEffect(() => {
    const query_program = { type: "Program" };
    dispatch(asyncGetAllPrograms(query_program));
    dispatch(asyncGetTotalCourses());
    dispatch(asyncGetAllMasterclass({ active: true }));
  }, []);

  const filterData = (query) => {
    const filterArr = allPrograms.filter((item) =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );
    setSearchList(filterArr);
  };

  useEffect(() => {
    if (isOpen) {
      hideOverflowBody();
    } else {
      closeBar();
    }
  }, [isOpen]);

  return (
    <>
      <Header />
      <div
        style={{ paddingTop: "100px" }}
        className={`subheader_list_detail subheader_list_fullwidth`}
      >
        <div className=" subheader_course_container">
          <div className="row">
            <div className="col-12 subheader_list_course_list">
              {!allPrograms || allPrograms.length === 0 ? (
                <div
                  className="row row-gap-5"
                  style={{
                    paddingBlock: "100px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <ColorRing
                    width={80}
                    height={80}
                    colors={[
                      "#3399FF",
                      "#3399FF",
                      "#3399FF",
                      "#3399FF",
                      "#3399FF",
                    ]}
                  />
                  <p>Loading Courses...</p>
                </div>
              ) : (
                <div className="xnmrph-course-show-main col-12">
                  {allPrograms ? (
                    allPrograms
                      .filter(
                        (item) =>
                          !(
                            item.slug === "digital-marketing-program"
                          )
                      )
                      .map((item, idx) => (
                        <div
                          className="xnmrph-course-card-neo"
                          onClick={() => {
                            navigate(`/${item.slug}`);
                          }}
                        >
                          <figure>
                            {idx === 0 ? (
                              <span className="course-card-badge">
                                <RiMedal2Line /> Bestseller
                              </span>
                            ) : idx === 1 ? (
                              <span className="course-card-badge">
                                <RiMedal2Line /> Bestseller
                              </span>
                            ) : idx === 2 ? (
                              <span className="course-card-badge trending">
                                {" "}
                                <FaArrowTrendUp /> Trending
                              </span>
                            ) : (
                              <></>
                            )}
                            <img src={item.image} alt="" />
                          </figure>
                          <div className="card-content">
                            <h3
                              className="card-head-met"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>{item.category}</span>
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  margin: "0px",
                                  gap: "3px",
                                }}
                              >
                                <span
                                  style={{
                                    margin: "0px",
                                    fontSize: "15px",
                                    fontWeight: "500",
                                    marginTop: "4px",
                                    marginRight: "4px",
                                  }}
                                >
                                  {getRating(item.category)}
                                </span>
                                <img
                                  src="/icons8-star-32.png"
                                  style={{ width: "20px" }}
                                  alt=""
                                />
                                <img
                                  src="/icons8-star-32.png"
                                  style={{ width: "20px" }}
                                  alt=""
                                />
                                <img
                                  src="/icons8-star-32.png"
                                  style={{ width: "20px" }}
                                  alt=""
                                />
                                <img
                                  src="/icons8-star-32.png"
                                  style={{ width: "20px" }}
                                  alt=""
                                />
                                <img
                                  src="/icons8-star-half-empty-32.png"
                                  style={{ width: "20px" }}
                                  alt=""
                                />
                              </p>
                            </h3>
                            <div style={{ padding: "20px" }}>
                              <p
                                className="course-card-title"
                                style={{
                                  color: "black",
                                  fontSize: "16px",
                                  fontWeight: "600",
                                }}
                              >
                                {item.title}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      svgObj[
                                        item.page_data.eligibility_steps[0]
                                          .step_description
                                      ],
                                  }}
                                ></div>

                                <p
                                  style={{
                                    // color: "#000",
                                    margin: "0px",
                                    lineHeight: "30px",
                                    fontSize: "14px",
                                    color: "#888",
                                  }}
                                  className="course-card-eligibility"
                                >
                                  {
                                    item.page_data.eligibility_steps[0]
                                      .step_name
                                  }
                                </p>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      svgObj[
                                        item.page_data.eligibility_steps[1]
                                          .step_description
                                      ],
                                  }}
                                ></div>
                                <p
                                  style={{
                                    // color: "#000",
                                    margin: "0px",
                                    lineHeight: "25px",
                                    fontSize: "14px",
                                    color: "#888",
                                  }}
                                  className="course-card-eligibility"
                                >
                                  {
                                    item.page_data.eligibility_steps[1]
                                      .step_name
                                  }
                                </p>
                              </div>

                              <div className="course-card-button-tray">
                                <span className="course-bottom-badge-1">
                                  Live Program
                                </span>
                                <span className="course-bottom-badge-2">
                                  Remote / Online Mode
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <ColorRing
                      width={90}
                      height={90}
                      colors={[
                        "#037ff3",
                        "#e75dbb",
                        "#037ff3",
                        "#e75dbb",
                        "#037ff3",
                      ]}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const HomeAbout = ({ closeBar }) => {
  const sidebarRef = useRef(null);

  useOutsideClickHeader(sidebarRef, closeBar);

  return (
    <motion.div
      key={"header-about-xnmrph"}
      transition={{ ease: [0.79, 0.14, 0.15, 0.86], duration: 0.5 }}
      initial={{ y: -300, opacity: 1 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
      className="subheader_list_detail"
      ref={sidebarRef}
    >
      <div className="subheader_about_container">
        <div className="row">
          <div className="col-2"></div>

          <div
            className="col-10 d-flex align-items-center"
            style={{ padding: "20px", paddingInline: "100px" }}
          >
            <div className="subheader_about_list">
              <ul className="row">
                <li className="col-6">
                  <NavLink to={AboutRoutes.whyMetBrains}>
                    Why MetBrains?
                  </NavLink>
                </li>
                {/* <li className="col-6">
                  <NavLink to={AboutRoutes.meetourteam}>Meet our team</NavLink>
                </li> */}
                <li className="col-6">
                  <NavLink to={AboutRoutes.contactus}>Contact Us</NavLink>
                </li>
                {/* <li className="col-6">
                  <NavLink to={AboutRoutes.jointeam}>Join our team</NavLink>
                </li> */}
                <li className="col-6">
                  <NavLink to={AboutRoutes.ourpolicy}>Our Policies</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const HomeVirtual = ({ closeBar }) => {
  const sidebarRef = useRef(null);
  useOutsideClickHeader(sidebarRef, closeBar);

  return (
    <div className="subheader_list_detail" ref={sidebarRef}>
      <div className="subheader_about_container">
        <div className="row">
          <div className="col-4">
            {/* images["virtual_bg_1.png"] */}
            <Image
              alt=""
              fallback={<Shimmer width={450} height={240} />}
              src={"https://metbrains-demo-bucket.s3.ap-southeast-2.amazonaws.com/virtual_bg_1+(1).png"}
            />
            <div className="subheader_howit_works">
              <NavLink to={"/study-and-internship"}>
                <span>How It works</span>
                <RightArrow />
              </NavLink>
            </div>
          </div>

          <div className="col-6 d-flex align-items-center p-5">
            <div className="subheader_about_list">
              <ul className="row px-5 ">
                {/* <li className="col-12 ">
                  <NavLink to={VirtualInternshipRoutes.virtual}>
                    Virtual Internship experience
                  </NavLink>
                </li> */}
                <li className="col-12">
                  <NavLink to={VirtualInternshipRoutes.study_and_internship}>
                    {/* Study + Internship */}
                    MetBrains Global Training & Internship Program
                  </NavLink>
                </li>

                <li className="col-12">
                  <NavLink to={VirtualInternshipRoutes.oyip}>
                    {/* Study + Internship */}
                    MetBrains Youth Internship Program
                  </NavLink>
                </li>
                <li className="col-12">
                  <NavLink to={VirtualInternshipRoutes.placed}>
                    {" "}
                    Placed Testimonies
                  </NavLink>
                </li>
                <li className="col-12">
                  <NavLink to={VirtualInternshipRoutes.apply_now}>
                    Apply now
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeCommunity = ({ closeBar }) => {
  const sidebarRef = useRef(null);
  useOutsideClickHeader(sidebarRef, closeBar);

  return (
    <motion.div
      key={"header-about-xnmrph"}
      transition={{ ease: [0.79, 0.14, 0.15, 0.86], duration: 0.5 }}
      initial={{ y: -300, opacity: 1 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
      className="subheader_list_detail"
      ref={sidebarRef}
    >
      <div className="subheader_about_container">
        <div className="row">
          <div className="col-2"></div>

          <div className="col-10 d-flex align-items-center p-5">
            <div className="subheader_about_list">
              <ul className="row px-5 ">
                <li className="col-12 ">
                  <NavLink to={CommunityRoutes.facultyandmentors}>
                    Faculty and Mentors
                  </NavLink>
                </li>

                <li className="col-12">
                  <NavLink to={CommunityRoutes.whatTestimonies}>
                    What our testimonies are saying?
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const HomeBlogs = ({ closeBar }) => {
  const sidebarRef = useRef(null);

  useOutsideClickHeader(sidebarRef, closeBar);

  return (
    <motion.div
      key={"header-about-xnmrph"}
      transition={{ ease: [0.79, 0.14, 0.15, 0.86], duration: 0.5 }}
      initial={{ y: -300, opacity: 1 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
      className="subheader_list_detail"
      ref={sidebarRef}
    >
      <div className="subheader_about_container">
        <div className="row">
          <div className="col-4">
            <Image
              alt=""
              fallback={<Shimmer width={450} height={240} />}
              src={"https://metbrains-demo-bucket.s3.ap-southeast-2.amazonaws.com/blog_bg_1+(1).png"}
            />
            <div className="subheader_howit_works">
              <NavLink to="/study-and-internship">
                <span>How It works</span>
                <RightArrow />
              </NavLink>
            </div>
          </div>

          <div className="col-6 d-flex align-items-center p-5">
            <div className="subheader_about_list">
              <ul className="row px-5 ">
                <li className="col-12 ">
                  <NavLink to={BlogRoutes.ourblogs}>Our Blogs</NavLink>
                </li>
                <li className="col-12">
                  <NavLink to={BlogRoutes.blogregister}>
                    Register as Blogger
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
